import AboutValuesData from "./AboutValuesData"

const AboutValues = () => {
    return (
        <div className="AboutValues u-paddingSection">
            <AboutValuesData title='Our History' text="Trippy is owned and managed by Trippy .In Pvt. Ltd., a leading brand in web designing services and e-commerce solutions. Trippy .In Pvt. Ltd. is counted for its expertise in web solutions and its top ranking business portals. Our invincible expertise and rich experience has raised our spirit to reach ahead from our client's expectation. Commendable success rate of other portals managed by Trippy is a live paradigm of our work excellence." />
            <AboutValuesData title='Our Mission' text="Our mission is to touch the horizon where our capabilities may successfully meet with the requirements of our clients, that too with ultimate transparency and cost-effectiveness." />
            <AboutValuesData title='Our Vision' text="To sow the seeds of par-excellence services with customer centric approach and reap the trust of worldwide clients." />
        </div>
    )
}

export default AboutValues